import React from 'react';
import './Menubar.css';
import Logo from '../assets/codelearn.svg';
import Htmlicon from '../assets/html icon.svg';
import Cssicon from '../assets/css icon.svg';
import Javascicon from '../assets/javascript icon.svg';
import Webicon from '../assets/website development icon.svg';
import Fronticon from '../assets/frontend development icon.svg';
import { Link } from 'react-router-dom';


const linkStyle = {
  textDecoration: "none",
  color: "#000"
};

const choosegoalClick = () => {
  if (document.getElementsByClassName("choosegoal")[0].style.display === "flex")
  {  
    document.getElementsByClassName("choosegoal")[0].style.display = "none";
  }

  else
  {  
    document.getElementsByClassName("choosegoal")[0].style.display = "flex";
    document.getElementsByClassName("mentor")[0].style.display = "none";
    document.getElementsByClassName("practice")[0].style.display = "none";
  }
}

const practiceClick = () => {
  if (document.getElementsByClassName("practice")[0].style.display === "flex")
  {  
    document.getElementsByClassName("practice")[0].style.display = "none";
  }

  else
  {  
    document.getElementsByClassName("practice")[0].style.display = "flex";
    document.getElementsByClassName("mentor")[0].style.display = "none";
    document.getElementsByClassName("choosegoal")[0].style.display = "none";
  }
}

const mentorClick = () => {
  if (document.getElementsByClassName("mentor")[0].style.display === "flex")
  {  
    document.getElementsByClassName("mentor")[0].style.display = "none";
  }

  else
  {  
    document.getElementsByClassName("mentor")[0].style.display = "flex";
    document.getElementsByClassName("practice")[0].style.display = "none";
    document.getElementsByClassName("choosegoal")[0].style.display = "none";
  }
}

const hamMenu = () => {
  if (document.getElementsByClassName("hamcontent")[0].style.display === "flex") {
    document.getElementsByClassName("hamcontent")[0].style.display = "none";
  } else {
    document.getElementsByClassName("hamcontent")[0].style.display = "flex";
  }
}

const Menubar = () => {
  return (

    <div className='Bar'>
    
      <div className='navigation'>
        
        <div className='navcol1'>
          <Link to = '/'><img src={Logo} alt='codelearn' /></Link>
           <nav>
             <a onClick={choosegoalClick}>What's your goal?</a>
             <a onClick={practiceClick}>Practice</a>
             <a onClick={mentorClick}>Mentor me</a>
           </nav>
        </div>

        <div class="hammenu" onClick={hamMenu}>
            <span className="hambtn">Menu</span>
        </div>  
        <div className="hamcontent" id="myLinks">
        <div className='webdev'>
             <h3>Explore web development</h3>
                  <div className='opt'>
                  <Link to = "/html" style={linkStyle}><h3>HTML basics</h3></Link>
                  </div>
                  <div className='opt'>
                  <Link to = "/css" style={linkStyle}><h3>CSS basics</h3></Link>
                  </div>
                  <div className='opt'>
                  <Link to = "/js" style={linkStyle}><h3>Javascript basics</h3></Link>
                  </div>
                </div>  

          <div className='webdev'>
                  <h3>Gain a professional skill</h3>
                  <div className='opt'>
                       <h3>Website Development</h3>
                       <p>Coming Soon</p>
                  </div>
                  <div className='opt'>
                       <h3>Front-end Development</h3>
                       <p>Coming Soon</p>
                  </div>
          </div>

          <div className='webdev'>
                  <h3>Practice</h3>
                  <p>Upcoming</p>
          </div>

          <div className='webdev'>
                  <h3>Mentor</h3>
                  <p>Coming Soon</p>
          </div>

          <div className='webdev'>
                <button>Login</button>
          </div>
                  
        </div>  

      </div>


      <div id='navcol0'>
          <button>Login</button>
      </div>

      
      <div className='choosegoal' id='desktopchoosegoal'>
          <div className='webdev'>
             <h3>Explore web development</h3>
                  <div className='opt'>
                       <img src={Htmlicon} />
                       <Link to = "/html" style={linkStyle}><h3>HTML basics</h3></Link>
                       <p>Difficulty level : Beginner</p>
                  </div>
                  <div className='opt'>
                       <img src={Cssicon} id='cssicon'/>
                       <Link to = "/css" style={linkStyle}><h3>CSS basics</h3></Link>
                       <p>Difficulty level : Beginner</p>
                  </div>
                  <div className='opt'>
                       <img src={Javascicon} />
                       <Link to = "/js" style={linkStyle}><h3>Javascript basics</h3></Link>
                       <p>Difficulty level : Beginner</p>
                  </div>
          </div>

          <div className='webdev'>
                  <h3>Gain a professional skill</h3>
                  <div className='opt'>
                       <img src={Webicon} />
                       <h3>Website Development</h3>
                       <p>Coming Soon</p>
                  </div>
                  <div className='opt'>
                       <img src={Fronticon} />
                       <h3>Front-end Development</h3>
                       <p>Coming Soon</p>
                  </div>
          </div>
      </div>

      <div className='practice' id='desktoppractice'>
        <p>Upcoming</p>
      </div>

      <div className='mentor' id='desktopmentor'>
        <p>Coming Soon</p>
      </div>

      </div>
    
  );
};

export default Menubar;
